//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'
import {db} from '../boot/firebase'
import { Notify } from 'quasar'

export default {
  name: 'Domains',
  data () {
    return {
      pagination: {
        rowsPerPage: 0
      },
      columns: [
        { name: 'name', align: 'left', label: 'Name', field: 'name', sortable: true },
        { name: 'nif', align: 'left', label: 'NIF', field: 'nif', sortable: true },
        { name: 'domain', align: 'left', label: 'Domain', field: 'domain', sortable: true },
        { name: 'emails', align: 'left', label: 'Emails', field: 'emails' },
        { name: 'state', label: 'State', field: 'state', sortable: true }
      ],
      clients: [],
      client: {
        name: '',
        nif: ''
      },
      file: null,
      namecol: 7,
      nifcol: 8,
      startrec: 1,
      endrec: 5,
      filter: '',
      selected: [],
      isLoading: true,
      opennewclient: false,
      opencsv: false
    }
  },
  computed: {
    emailslabel() {
      return "Emails ("+(this.selected).length+")"
    },
    displayData () {
      return this.clients.filter((item, index) => {
        if(this.filter) {
          var aux = 0;
          for(var x in item) {
            var i = item[x]
            var vname;
            if(typeof i == 'number' || typeof i == 'boolean'){
              vname = i
              if( vname == this.filter.toLowerCase() ) {
                aux = 1;
                break;
              }
            } else {
              if(typeof i == 'string') {
                vname = (i && i != '' ? i.toLowerCase() : '');
                if( vname.indexOf(this.filter.toLowerCase()) > -1 ) {
                  aux = 1;
                  break;
                }
              }
            }
          }
          if( aux == 1 ) {
            return item
          }
        } else {
          return item
        }
      })
    },
    validate: function () {
      // `this` points to the vm instance
      return this.client.name && this.client.nif && this.client.nif.length == 9
    },
    validatecsv: function() {
      return this.namecol > -1 && this.nifcol > -1 && this.file
    }
  },
  methods: {
    processEmails() {
      let vm = this

      this.selected.forEach(element => {
          let doc_id = element['.key']

              axios.get('http://emails.boostingideas.com/emails.php?domain=' + element.domain)
              .then(function (response_emails) {
                console.log(response_emails)
                let emails = []
                if(response_emails.data && response_emails.data.emails && response_emails.data.emails.length > 0) {
                  response_emails.data.emails.forEach(function(item){
                    emails.push(item.email)
                  })
                }
                db.collection('clients').doc(doc_id).update({
                    state: 'EM',
                    emails: emails
                })
              })

      })
      this.selected = []
    },
    handleFileUpload(){
      this.file = this.$refs.file.files[0];
    },
    newclient() {
      this.client.name = ''
      this.client.nif = ''
      this.opennewclient = true
    },
    newcsv() {
      this.client.name = ''
      this.client.nif = ''
      this.opencsv = true
    },
    insertClient(name,nif) {
      if(name !='' && nif != '') {
        db.collection('clients').add({
          name: name,
          nif: nif,
          domain: '-',
          state: 'I'
        }).then((doc) => {
          let doc_id = doc.id
          axios.get('http://contactos.ruinascimento.com/domain.php?nif=' + nif)
          .then(function (response) {
            if(response.data.status == 'D') {
              //axios.get('http://emails.boostingideas.com/emails.php?domain=' + response.data.website)
              //.then(function (response_emails) {
                let emails = []
                //if(response_emails.data.emails.length > 0) {
                  /*response_emails.data.emails.forEach(function(item){
                    emails.push(item.email)
                  })*/
                //}
                db.collection('clients').doc(doc_id).update({
                    domain: response.data.website,
                    state: response.data.status,
                    emails: emails
                })
              //})
            } else {
              db.collection('clients').doc(doc_id).update({
                  domain: 'n/d',
                  state: response.data.status
              })
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          Notify.create({
            timeout: 2000,
            html: true,
            color: 'green',
            icon: 'check',
            message: 'Client '+name+' created successfully'
          });
        })
      }
    },
    savecsv() {
      var vm = this
      vm.opencsv = false
      vm.isLoading = true
      let formData = new FormData();
      formData.append('fileToUpload', this.file);
      formData.append('namecol', this.namecol)
      formData.append('nifcol', this.nifcol)
      formData.append('startrec', this.startrec)
      formData.append('endrec', this.endrec)
      axios.post( 'http://contactos.ruinascimento.com/csv.php',
          formData,
          {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
        }
      ).then(function(r){
        (r.data.clients).forEach(function(item){
          vm.insertClient(item.name,item.nif) 
        })
        vm.isLoading = false
      })
    },
    saveclient() {
      var vm = this
      vm.isLoading = true
      this.insertClient(vm.client.name,vm.client.nif) 
      vm.isLoading = false
      vm.opennewclient = false
    }
  },
  created() {
    var vm = this
    this.$binding("clients", db.collection("clients"))
      .then((clients) => {
        vm.isLoading = false
    })
  },
}
